// eslint-disable-next-line import/no-cycle
import InterviewForm from './interviewEditor';

export default InterviewForm;
